function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6704 3.50889C12.4566 1.4142 10.3006 0.134473 7.90318 0.0855664C7.80084 0.083457 7.69783 0.083457 7.59545 0.0855664C5.19802 0.134473 3.04209 1.4142 1.82826 3.50889C0.587555 5.64998 0.55361 8.22185 1.73744 10.3887L6.69693 19.4663C6.69916 19.4703 6.70138 19.4744 6.70369 19.4783C6.92189 19.8576 7.31279 20.084 7.74939 20.084C8.18595 20.084 8.57685 19.8576 8.79502 19.4783C8.79732 19.4744 8.79955 19.4703 8.80177 19.4663L13.7613 10.3887C14.945 8.22185 14.9111 5.64998 13.6704 3.50889ZM7.74931 9.1465C6.19849 9.1465 4.93681 7.88482 4.93681 6.334C4.93681 4.78318 6.19849 3.5215 7.74931 3.5215C9.30013 3.5215 10.5618 4.78318 10.5618 6.334C10.5618 7.88482 9.30017 9.1465 7.74931 9.1465Z",
  fill: "white"
});
function SvgMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapa);
export default __webpack_public_path__ + "static/media/mapa.e41f9833fcbaacac725d7a8aa8b1b508.svg";
export { ForwardRef as ReactComponent };